let language = {
    "terms:AcceptanceOfTerms": "接受条款",
    "terms:Content": "内容",
    "terms:StoragePolicy": "存储政策",
    "terms:UseOfTheWebsite": "网站使用",
    "terms:IntellectualProperty": "知识产权",
    "terms:PrivacyPolicy": "隐私政策",
    "terms:WebAddresses": "网址（URL）",
    "terms:LimitedWarranty": "有限保修",
    "terms:LimitationOfLiability": "责任限制",
    "terms:Title": "标题",
    "terms:ShippingTime": "发货时间",
    "terms:Restrictions": "运输限制",
    "terms:Interpretation": "解释",
    "terms:Arbitration": "仲裁",
    "terms:Severability": "可分割性",
    "terms:General": "一般条款",
    "terms:OurAddress": "我们的地址"
};

export { language }
